<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>操作记录</el-breadcrumb-item>
		</el-breadcrumb>
		
			<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-input placeholder="请输入搜索内容"  @keyup.enter.native="search"  v-model="formInline.operaTion" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-date-picker
					size="small"
					v-model="dateData"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					@change="getDate"
					end-placeholder="结束日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			</el-form-item>
		</el-form>
		<!-- 数据列表 -->
		<el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" ref="tablelist" stripe >
			<el-table-column align="center" type="index" width="60">
			</el-table-column>
			<!-- <el-table-column prop="id" align="center" label="id" width="100">
			</el-table-column> -->
			<el-table-column prop="createDate" label="时间" width="200">
			</el-table-column>
			<el-table-column prop="operaTion" label="详情" show-overflow-tooltip min-width="300" >
			</el-table-column>
			
			<!-- <el-table-column prop="ip" label="ip地址" show-overflow-tooltip width="200"> 
			</el-table-column> -->
			
		</el-table>
		
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage" ></Pagination>
		
		
	</div>
</template>

<script>
	import { findSysLogList } from '../../api/userMG.js'
	import { timestampToTime} from '@/utils/util'
	import Pagination from '../../components/Pagination'
	export default{
		data(){
			return{
				loading:false,
				showPage:true,
				formInline:{
					startDate:'',
					endDate:"",
					operaTion:'',
					currentPage: 1,
					pageSize: 10,
				},
				dateData:[],
				dataList:[],
				pageparm:{
					currentPage: 1,
					pageSize:10,
					total: 0
				}
				
			}
			
		},
		// 注册组件
		components: {
			Pagination
		},
		created(){
			this.getData()
		},
		methods: {
			search() {
				this.pageparm.currentPage = 1
				this.formInline.currentPage = 1
				this.showPage = false
				this.getData()
				this.$nextTick(()=>{
					this.showPage = true
				})
			},
			getData(){
				this.loading = true
				findSysLogList(this.formInline).then( res =>{
					this.loading = false
					if(res.status == 1){
						this.dataList = res.data.data
						this.pageparm.currentPage = this.formInline.currentPage
						this.pageparm.pageSize = this.formInline.pageSize
						this.pageparm.total = res.data.totalCount
					}
				})
				.catch(err => {
					this.loading = false
					this.$message.error('获取数据失败，请稍后再试！')
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getData()
			},
			getDate(val){
				this.formInline.startTime = timestampToTime(this.dateData[0]).substring(0, 10)
				this.formInline.endTime = timestampToTime(this.dateData[1]).substring(0, 10)
				this.getData()
			}
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/prepayment/operation.vue